import { useTranslation } from "react-i18next";
import { List, Clock, Map } from "lucide-react";

export type ViewMode = "list" | "timeline" | "map";

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewModeToggle({ value, onChange }: ViewModeToggleProps) {
  const { t } = useTranslation();

  const modes: { value: ViewMode; icon: typeof List; label: string }[] = [
    { value: "list", icon: List, label: t("timeline.listView") },
    { value: "timeline", icon: Clock, label: t("timeline.timelineView") },
    { value: "map", icon: Map, label: t("map.mapView") },
  ];

  return (
    <div className="flex items-center justify-end gap-2">
      <span className="hidden text-sm text-muted-foreground sm:inline">
        {t("timeline.viewMode")}:
      </span>
      <div className="flex rounded-lg border bg-muted p-0.5">
        {modes.map((mode) => {
          const Icon = mode.icon;
          const isActive = value === mode.value;

          return (
            <button
              key={mode.value}
              onClick={() => onChange(mode.value)}
              title={mode.label}
              className={`flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm transition-all ${
                isActive
                  ? "bg-background text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon className="h-4 w-4" />
              <span>{mode.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
